<pp-select
  [ppItems]="items"
  [ppSelectedItem]="items[selectedIndex]"
  (ppSelectItem)="selectItem($event)"
  [ppNoSearchBar]="false"
  [ppDisabled]="ppDisabled"
  require
  >
  <ng-container selected>
    @if (selectedIndex !== -1) {
      <span class="fleetAccountSelect__content">
        {{ items[selectedIndex].label }}
      </span>
    }

    @if (selectedIndex === -1) {
      <span class="fleetAccountSelect__placeholder">
        {{ 'choose_account' | ppTranslate }}
      </span>
    }
  </ng-container>
</pp-select>
